import script from "./AddProfileActionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProfileActionCard.vue?vue&type=script&setup=true&lang=ts"

import "./AddProfileActionCard.vue?vue&type=style&index=0&id=071729e8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071729e8"]])

export default __exports__